import React, { useState } from 'react';
import { IPicture } from '../../../../../../../model/shared/IPicture';
import CampaignFeedbackForm from './CampaignFeedbackForm';
import CampaignFeedbackPreview from './CampaignFeedbackPreview';
import { Company } from '../../../../../../../model/user/Company';

export interface IFeedbackData {
    id: number;
    feedbackFile: IPicture[];
    teamFeedback: string;
    company?: Company;
    show: boolean;
}
interface CampaignFeedbackProps {
    setFeedbackData: React.Dispatch<React.SetStateAction<IFeedbackData | undefined>>;
    feedbackData?: IFeedbackData;
}

const CampaignFeedback = ({ setFeedbackData, feedbackData }: CampaignFeedbackProps) => {
    const [isFormOpened, setIsFormOpened] = useState<boolean>(false);

    return (
        <>
            {isFormOpened ? (
                <CampaignFeedbackForm
                    feedbackData={feedbackData as IFeedbackData}
                    setFeedbackData={setFeedbackData}
                    setIsFormOpened={setIsFormOpened}
                />
            ) : (
                <CampaignFeedbackPreview
                    setIsFormOpened={setIsFormOpened}
                    feedbackData={feedbackData as IFeedbackData}
                />
            )}
        </>
    );
};

export default React.memo(CampaignFeedback);
